import axios from "axios";
import { workstationId } from "../TerminalCheckout/useTerminalCheckout";

const active = new Map();
const endpoint = "method/restaurant_management.kiosk_print_jobs.";
const call = async (method, data) => (await axios.post(endpoint + method, data, { timeout: method === "status" ? 5000 : 60000 })).data.message;

export function printNativeReceipt({ doctype, name, reprint = false, onRetryUsed }) {
    const key = `${doctype}.${name}`;
    if (active.has(key)) return active.get(key);
    const operation = (async () => {
        let job;
        try {
            job = await call("request_print", { doctype, name, workstation_id: workstationId(), reprint: reprint ? 1 : 0 });
        } catch (error) {
            // A lost response may still have created a job; never offer a blind retry.
            if (!error.response || error.response.status >= 500) error.printUnknown = true;
            throw error;
        }
        if (job?.mode !== "native") throw new Error("Printing configuration changed; reload the kiosk");
        const deadline = Date.now() + 160000;
        while (true) {
            onRetryUsed?.(Boolean(job.retry_used));
            if (job.status === "Spooled") return;
            if (job.status === "Failed") throw new Error("Receipt could not be prepared or the printer was unavailable");
            if (job.status === "Unknown" || Date.now() > deadline) {
                const error = new Error("Print result is unconfirmed; ask the cashier before printing again");
                error.printUnknown = true;
                throw error;
            }
            await new Promise(resolve => setTimeout(resolve, 1000));
            try { job = await call("status", { name: job.name }); }
            catch (error) {
                // Status reads are safe to retry. A slow/lost read must not hold
                // the display for a minute or submit another print request.
                if (error.response && error.response.status < 500 && error.response.status !== 429) {
                    error.printUnknown = true;
                    throw error;
                }
            }
        }
    })();
    active.set(key, operation);
    operation.finally(() => active.delete(key)).catch(() => {});
    return operation;
}
